import { gateway as MoltinGateway } from "@moltin/sdk"
import { MoltinClient } from '@moltin/request'

const Moltin = MoltinGateway({
  client_id: process.env.GATSBY_MOLTIN_CLIENT_ID
})

const client = new MoltinClient({
  client_id: process.env.GATSBY_MOLTIN_CLIENT_ID,
})

export { Moltin, client }
